import { render, staticRenderFns } from "./OurEmissions.vue?vue&type=template&id=537de28a&"
import script from "./OurEmissions.vue?vue&type=script&lang=js&"
export * from "./OurEmissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports